import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("../views/Home.vue"),
    props: true,
  },
  {
    path: "/login",
    name: "login",
    meta: { allowAnonymous: true },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/password_reset",
    name: "password_reset",
    meta: { allowAnonymous: true },
    component: () => import("../views/PasswordReset.vue"),
  },
  {
    path: "/sign_up",
    name: "sign_up",
    meta: { allowAnonymous: true },
    component: () => import("../views/SignUp.vue"),
  },
  {
    path: "/success",
    name: "success",
    meta: { allowAnonymous: true },
    component: () => import("../views/Success.vue"),
  },
  {
    path: "/fling/:flingId(\\d+)",
    name: "fling",
    component: () => import("../views/Fling.vue"),
    props(route) {
      const props = { ...route.params };
      props.flingId = +props.flingId;
      return props;
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile.vue"),
  },
  {
    path: "/end_trail",
    name: "end_trail",
    component: () => import("../views/EndTrail.vue"),
  },
  {
    path: "/edit_profile",
    name: "edit_profile",
    component: () => import("../views/EditProfile.vue"),
  },
  {
    path: "/edit_card",
    name: "edit_card",
    component: () => import("../views/EditCard.vue"),
  },
  {
    path: "/edit_package",
    name: "edit_package",
    component: () => import("../views/EditPackageNew.vue"),
  },
  {
    path: "/purchase_flings",
    name: "purchase_flings",
    component: () => import("../views/PurchaseFlings.vue"),
  },
  {
    path: "/shop_flings",
    name: "shop_flings",
    component: () => import("../views/ShopFlings.vue"),
  },
  {
    path: "/purchase_tokens",
    name: "purchase_tokens",
    component: () => import("../views/PurchaseTokens.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.allowAnonymous)) {
    next();
  } else if (store.state.userData === null) {
    next({
      name: "login",
    });
  } else {
    next();
  }
});

export default router;
